import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import { toast } from "react-toastify";

class   SchoolfeecategoryForm extends Component{

    state = {
        id : "",
        category : "",
        error : "",
        
        isModal : false,
        title : "",
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    storeSchoolfeecategory = (val = null) =>{
        var data = {
                category : this.state.category,
                operation : this.state.id ? (val === 1 ? "Archiver" : "Editer" ) : "Ajouter",
            }

        var request = this.state.id ? axios.put('schoolfeecategories/'+this.state.id, data) : axios.post('schoolfeecategories', data);
        request.then((response) =>{
            this.props.showModal()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error) => {
            this.setState({
                error : error.response.data.msg
            })
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }
  

    edit=()=>  {
        this.form()
    }

    form=()=>{
        this.setState({
            id: this.props.formData ? this.props.formData.id : "",
            category: this.props.formData ? this.props.formData.category : "",
            title : this.props.formData ? "Modifier le type de paiement" : "Ajouter le type de paiement",
            error : "",
        })
    }

    showModal = () => {
        this.setState({
            isModal : !this.state.isModal,
        })
    }

    render(){
        
        return(
            <div>


                <Modal 
                    show={this.props.isModal} 
                    onHide={this.props.showModal}
                    onEntered={this.edit}
                    size="lg" 
                    contentClassName="ev-form-modal ev-form-modal--compact" backdrop={"static"}
                >
                    <Modal.Header>
                        <div className="student-form__heading">
                            <span className="student-form__heading-icon"><FeatherIcon icon="box" size={18} /></span>
                            <div>
                                <span className="student-form__eyebrow">{ this.state.title}</span>
                                <Modal.Title>{ this.state.title}</Modal.Title>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body className="row ev-form-body">
                        <span className="text-danger text-small small">{ this.state.error }</span>
                        <div className="col-md-12 mt-2 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Type de paiement</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" onChange={this.handleInput} name="category" value={this.state.category} id="nom-id-icon" />
                                    <div className="form-control-icon"><FeatherIcon icon="box" /></div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <span className="ev-form-footer-note"><FeatherIcon icon="info" size={13} /> Parametrage des type de frais scolaire</span>
                        <button onClick={this.props.showModal } className="btn btn-light ev-form-button"><FeatherIcon icon="corner-down-left" /> Fermer</button>
                        <button onClick={() => this.storeSchoolfeecategory()} className="btn btn-primary ev-form-button"><FeatherIcon icon="check-square" /> Sauvegarder</button>
                    </Modal.Footer>
                </Modal>
    </div>
        )
    }
}
export default SchoolfeecategoryForm;